import React, { useState } from "react";
import ReassignTab from "./ReassignTab";
import { UsersTab } from "../../features/settings/tabs/UsersTab";
import { TeamsTab } from "../../features/settings/tabs/TeamsTab";
import { HierarchyTab } from "../../features/settings/tabs/HierarchyTab";
import { GeographiesTab } from "../../features/settings/tabs/GeographiesTab";
import { AssignmentsTab } from "../../features/settings/tabs/AssignmentsTab";
import { MetaCampaignsTab, IntegrationStatusCard } from "../../features/settings/tabs/MetaCampaignsTab";
import { MetaCapiTab } from "../../features/settings/tabs/MetaCapiTab";
import { AdminDisclosureCard } from "../../features/settings/settingsHelpers";

// ── SettingsView ───────────────────────────────────────────────────────────────

const TABS = ["Users", "Teams", "Geographies", "Assignments", "Hierarchy", "Reassign", "Campaigns", "Meta CAPI"];

function SettingsView({ currentUser, integrationDiagnostics, onContextChange, onRefreshIntegrationDiagnostics }) {
  const [activeTab, setActiveTab] = useState("Users");
  const [integrationsOpen, setIntegrationsOpen] = useState(false);

  if (currentUser.role !== "admin") {
    return (
      <section className="settings-shell">
        <div className="settings-card">
          <p className="login-kicker">Restricted</p>
          <h2>CRM Admin settings are available only to admin users.</h2>
          <p>This panel provides administrative configurations.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="settings-shell settings-admin-shell">
      <div className="settings-card settings-hero-card">
        <p className="login-kicker">CRM Admin</p>
        <h2>Operations Control Center</h2>
        <p>Manage users, teams, geographies, assignments, and hierarchy from one cleaner admin workspace.</p>
      </div>

      <AdminDisclosureCard
        title="Integrations"
        description="Check Facebook and Ozonetel configuration only when you need it."
        actionLabel="Open Status"
        open={integrationsOpen}
        onToggle={() => setIntegrationsOpen((current) => !current)}
        actions={(
          <button
            type="button"
            className="secondary-ghost"
            onClick={onRefreshIntegrationDiagnostics}
            disabled={integrationDiagnostics.loading}
          >
            {integrationDiagnostics.loading ? "Refreshing..." : "Refresh status"}
          </button>
        )}
      >
        {integrationDiagnostics.error ? (
          <div className="message-banner error">{integrationDiagnostics.error}</div>
        ) : null}

        <div className="settings-integration-grid">
          <IntegrationStatusCard diagnostics={integrationDiagnostics.facebook} title="Facebook Leads" />
          <IntegrationStatusCard diagnostics={integrationDiagnostics.ozontel} title="Ozonetel" />
        </div>
      </AdminDisclosureCard>

      <div className="report-tab-strip settings-tab-strip">
        {TABS.map((tab) => (
          <button
            key={tab}
            type="button"
            className={`report-tab-button ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            <span>{tab}</span>
          </button>
        ))}
      </div>

      <div className="settings-card settings-content-card">
        {activeTab === "Users" && <UsersTab onContextChange={onContextChange} />}
        {activeTab === "Teams" && <TeamsTab onContextChange={onContextChange} />}
        {activeTab === "Geographies" && <GeographiesTab onContextChange={onContextChange} />}
        {activeTab === "Assignments" && <AssignmentsTab onContextChange={onContextChange} />}
        {activeTab === "Hierarchy" && <HierarchyTab />}
        {activeTab === "Reassign" && <ReassignTab />}
        {activeTab === "Campaigns" && <MetaCampaignsTab />}
        {activeTab === "Meta CAPI" && <MetaCapiTab />}
      </div>
    </section>
  );
}

export default SettingsView;
